export default "__VITE_ASSET__b0368f74__"